module.exports = __webpack_public_path__ + "072be4acadfa343241e5a26caa7b6941.pdf";